// Code generated by gen-relref. DO NOT EDIT.

export type File =
    '/' |
    '/100-percent-embroidered-patches' |
    '/100-percent-embroidered-patches/index' |
    '/100-percent-embroidered-patches/index.md' |
    '/3d-challenge-coins' |
    '/3d-challenge-coins/index' |
    '/3d-challenge-coins/index.md' |
    '/75-percent-embroidered-patches' |
    '/75-percent-embroidered-patches/index' |
    '/75-percent-embroidered-patches/index.md' |
    '/_index' |
    '/_index.html' |
    '/about-depot' |
    '/about-depot.html' |
    '/about-us' |
    '/about-us.html' |
    '/about-us/index' |
    '/about-us/index.md' |
    '/all-pricing' |
    '/all-pricing.html' |
    '/all-products' |
    '/all-products.html' |
    '/blog' |
    '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan' |
    '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan/index' |
    '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan/index.md' |
    '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b' |
    '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b/index' |
    '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b/index.md' |
    '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85' |
    '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85/index' |
    '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85/index.md' |
    '/blog/_index' |
    '/blog/_index.html' |
    '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax' |
    '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax/index' |
    '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax/index.md' |
    '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu' |
    '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu/index' |
    '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu/index.md' |
    '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb' |
    '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb/index' |
    '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb/index.md' |
    '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g' |
    '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g/index' |
    '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g/index.md' |
    '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy' |
    '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy/index' |
    '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy/index.md' |
    '/blog/collectible-music-festival-pins-ngcfce4fmqvo' |
    '/blog/collectible-music-festival-pins-ngcfce4fmqvo/index' |
    '/blog/collectible-music-festival-pins-ngcfce4fmqvo/index.md' |
    '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy' |
    '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy/index' |
    '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy/index.md' |
    '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk' |
    '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk/index' |
    '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk/index.md' |
    '/blog/creating-awesome-autumn-pins-ngcfca597vwy' |
    '/blog/creating-awesome-autumn-pins-ngcfca597vwy/index' |
    '/blog/creating-awesome-autumn-pins-ngcfca597vwy/index.md' |
    '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6' |
    '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6/index' |
    '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6/index.md' |
    '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj' |
    '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj/index' |
    '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj/index.md' |
    '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm' |
    '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm/index' |
    '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm/index.md' |
    '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn' |
    '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn/index' |
    '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn/index.md' |
    '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n' |
    '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n/index' |
    '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n/index.md' |
    '/blog/how-are-challenge-coins-given-nkghp1rednuo' |
    '/blog/how-are-challenge-coins-given-nkghp1rednuo/index' |
    '/blog/how-are-challenge-coins-given-nkghp1rednuo/index.md' |
    '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs' |
    '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs/index' |
    '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs/index.md' |
    '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7' |
    '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7/index' |
    '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7/index.md' |
    '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947' |
    '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947/index' |
    '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947/index.md' |
    '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho' |
    '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho/index' |
    '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho/index.md' |
    '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4' |
    '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4/index' |
    '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4/index.md' |
    '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2' |
    '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2/index' |
    '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2/index.md' |
    '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa' |
    '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa/index' |
    '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa/index.md' |
    '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn' |
    '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn/index' |
    '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn/index.md' |
    '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep' |
    '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep/index' |
    '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep/index.md' |
    '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur' |
    '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur/index' |
    '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur/index.md' |
    '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2' |
    '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2/index' |
    '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2/index.md' |
    '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o' |
    '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o/index' |
    '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o/index.md' |
    '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w' |
    '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w/index' |
    '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w/index.md' |
    '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk' |
    '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk/index' |
    '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk/index.md' |
    '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer' |
    '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer/index' |
    '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer/index.md' |
    '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f' |
    '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f/index' |
    '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f/index.md' |
    '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0' |
    '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0/index' |
    '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0/index.md' |
    '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru' |
    '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru/index' |
    '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru/index.md' |
    '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf' |
    '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf/index' |
    '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf/index.md' |
    '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5' |
    '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5/index' |
    '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5/index.md' |
    '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy' |
    '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy/index' |
    '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy/index.md' |
    '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17' |
    '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17/index' |
    '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17/index.md' |
    '/blog/top-5-trading-pin-upgrades-ngcfcoac5685' |
    '/blog/top-5-trading-pin-upgrades-ngcfcoac5685/index' |
    '/blog/top-5-trading-pin-upgrades-ngcfcoac5685/index.md' |
    '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f' |
    '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f/index' |
    '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f/index.md' |
    '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz' |
    '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz/index' |
    '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz/index.md' |
    '/blog/what-are-police-challenge-coins-ngcfb3kay74b' |
    '/blog/what-are-police-challenge-coins-ngcfb3kay74b/index' |
    '/blog/what-are-police-challenge-coins-ngcfb3kay74b/index.md' |
    '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf' |
    '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf/index' |
    '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf/index.md' |
    '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x' |
    '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x/index' |
    '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x/index.md' |
    '/buttons' |
    '/buttons/index' |
    '/buttons/index.md' |
    '/cart' |
    '/cart.html' |
    '/checkout' |
    '/checkout.html' |
    '/cloisonne-pins' |
    '/cloisonne-pins/index' |
    '/cloisonne-pins/index.md' |
    '/components/img-partial' |
    '/components/img-partial/index' |
    '/components/img-partial/index.md' |
    '/contact' |
    '/contact.html' |
    '/contact/success' |
    '/contact/success.html' |
    '/custom-bottle-openers' |
    '/custom-bottle-openers.html' |
    '/custom-bottle-openers/index' |
    '/custom-bottle-openers/index.md' |
    '/custom-lanyard-attachments' |
    '/custom-lanyard-attachments/index' |
    '/custom-lanyard-attachments/index.md' |
    '/dashboard' |
    '/dashboard.html' |
    '/diestruck' |
    '/diestruck/index' |
    '/diestruck/index.md' |
    '/dog-tags' |
    '/dog-tags/index' |
    '/dog-tags/index.md' |
    '/dual-plated-challenge-coins' |
    '/dual-plated-challenge-coins/index' |
    '/dual-plated-challenge-coins/index.md' |
    '/dye-sublimated-lanyards' |
    '/dye-sublimated-lanyards/index' |
    '/dye-sublimated-lanyards/index.md' |
    '/embroidered-patch-mesh-twill-charts' |
    '/embroidered-patch-mesh-twill-charts/index' |
    '/embroidered-patch-mesh-twill-charts/index.md' |
    '/embroidered-patch-thread-colors' |
    '/embroidered-patch-thread-colors/index' |
    '/embroidered-patch-thread-colors/index.md' |
    '/employee-pins' |
    '/employee-pins/index' |
    '/employee-pins/index.md' |
    '/error' |
    '/error.html' |
    '/faq' |
    '/faq.html' |
    '/forgot' |
    '/forgot.html' |
    '/free-quote' |
    '/free-quote.html' |
    '/gallery' |
    '/gallery.html' |
    '/heat-transfer-patches' |
    '/heat-transfer-patches/index' |
    '/heat-transfer-patches/index.md' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/about-depot' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/about-depot.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-pricing' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-pricing.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-products' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-products.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog/_index' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog/_index.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/cart' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/cart.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/checkout' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/checkout.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial/index' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial/index.md' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact/success' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact/success.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/custom-bottle-openers' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/custom-bottle-openers.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/dashboard' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/dashboard.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/error' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/error.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/forgot' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/forgot.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/free-quote' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/free-quote.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/gallery' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/gallery.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/join' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/join.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login-email' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login-email.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order-submitted' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order-submitted.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/make-order-payment' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/make-order-payment.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/track' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/track.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/overview' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/overview.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/password-reset' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/password-reset.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-history' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-history.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-methods' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-methods.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/presentation-options' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/presentation-options.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/privacy' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/privacy.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/products' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/products.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/profile' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/profile.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote/received' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote/received.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quotes' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quotes.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revision-requests' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revision-requests.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revisions' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revisions.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/search' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/search.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/shipping-options' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/shipping-options.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/support' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/support.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/tax-exemptions' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/tax-exemptions.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/terms' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/terms.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/testimonials' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/testimonials.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/thank-you' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/thank-you.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/types' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/types.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/uploads' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/uploads.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md' |
    '/imprinted-nylon-lanyards' |
    '/imprinted-nylon-lanyards/index' |
    '/imprinted-nylon-lanyards/index.md' |
    '/imprinted-polyester-lanyards' |
    '/imprinted-polyester-lanyards/index' |
    '/imprinted-polyester-lanyards/index.md' |
    '/imprinted-tube-lanyards' |
    '/imprinted-tube-lanyards/index' |
    '/imprinted-tube-lanyards/index.md' |
    '/join' |
    '/join.html' |
    '/keychains' |
    '/keychains/index' |
    '/keychains/index.md' |
    '/login' |
    '/login-email' |
    '/login-email.html' |
    '/login.html' |
    '/offset-pins' |
    '/offset-pins/index' |
    '/offset-pins/index.md' |
    '/order' |
    '/order-submitted' |
    '/order-submitted.html' |
    '/order.html' |
    '/orders' |
    '/orders.html' |
    '/orders/make-order-payment' |
    '/orders/make-order-payment.html' |
    '/orders/track' |
    '/orders/track.html' |
    '/overview' |
    '/overview.html' |
    '/password-reset' |
    '/password-reset.html' |
    '/patch-backing' |
    '/patch-backing/index' |
    '/patch-backing/index.md' |
    '/patch-edges' |
    '/patch-edges.html' |
    '/payment-history' |
    '/payment-history.html' |
    '/payment-methods' |
    '/payment-methods.html' |
    '/presentation-options' |
    '/presentation-options.html' |
    '/presentation-options/index' |
    '/presentation-options/index.md' |
    '/pricing' |
    '/pricing/index' |
    '/pricing/index.md' |
    '/privacy' |
    '/privacy.html' |
    '/products' |
    '/products.html' |
    '/profile' |
    '/profile.html' |
    '/pvc-patches' |
    '/pvc-patches/index' |
    '/pvc-patches/index.md' |
    '/quote' |
    '/quote.html' |
    '/quote/received' |
    '/quote/received.html' |
    '/quotes' |
    '/quotes.html' |
    '/race-medals' |
    '/race-medals/index' |
    '/race-medals/index.md' |
    '/revision-requests' |
    '/revision-requests.html' |
    '/revisions' |
    '/revisions.html' |
    '/ribbon-pins' |
    '/ribbon-pins/index' |
    '/ribbon-pins/index.md' |
    '/rush-trading-pin-design' |
    '/rush-trading-pin-design/index' |
    '/rush-trading-pin-design/index.html' |
    '/search' |
    '/search.html' |
    '/shipping-options' |
    '/shipping-options.html' |
    '/silkscreen-pins' |
    '/silkscreen-pins/index' |
    '/silkscreen-pins/index.md' |
    '/soft-enamel-pins' |
    '/soft-enamel-pins/index' |
    '/soft-enamel-pins/index.md' |
    '/specialty-lanyards' |
    '/specialty-lanyards/index' |
    '/specialty-lanyards/index.md' |
    '/support' |
    '/support.html' |
    '/tax-exemptions' |
    '/tax-exemptions.html' |
    '/terms' |
    '/terms.html' |
    '/testimonials' |
    '/testimonials.html' |
    '/thank-you' |
    '/thank-you.html' |
    '/trading-pin-design' |
    '/trading-pin-design/index' |
    '/trading-pin-design/index.html' |
    '/trading-pins' |
    '/trading-pins/index' |
    '/trading-pins/index.md' |
    '/types' |
    '/types.html' |
    '/uploads' |
    '/uploads.html' |
    '/usa-rush-pins' |
    '/usa-rush-pins/index' |
    '/usa-rush-pins/index.md' |
    '/woven-patch' |
    '/woven-patch/index' |
    '/woven-patch/index.md' |
    '/woven-polyester-lanyards' |
    '/woven-polyester-lanyards/index' |
    '/woven-polyester-lanyards/index.md';

export function IsFile(path: string): path is File {
    return [
        '/',
        '/100-percent-embroidered-patches',
        '/100-percent-embroidered-patches/index',
        '/100-percent-embroidered-patches/index.md',
        '/3d-challenge-coins',
        '/3d-challenge-coins/index',
        '/3d-challenge-coins/index.md',
        '/75-percent-embroidered-patches',
        '/75-percent-embroidered-patches/index',
        '/75-percent-embroidered-patches/index.md',
        '/_index',
        '/_index.html',
        '/about-depot',
        '/about-depot.html',
        '/about-us',
        '/about-us.html',
        '/about-us/index',
        '/about-us/index.md',
        '/all-pricing',
        '/all-pricing.html',
        '/all-products',
        '/all-products.html',
        '/blog',
        '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan',
        '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan/index',
        '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan/index.md',
        '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b',
        '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b/index',
        '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b/index.md',
        '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85',
        '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85/index',
        '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85/index.md',
        '/blog/_index',
        '/blog/_index.html',
        '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax',
        '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax/index',
        '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax/index.md',
        '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu',
        '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu/index',
        '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu/index.md',
        '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb',
        '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb/index',
        '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb/index.md',
        '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g',
        '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g/index',
        '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g/index.md',
        '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy',
        '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy/index',
        '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy/index.md',
        '/blog/collectible-music-festival-pins-ngcfce4fmqvo',
        '/blog/collectible-music-festival-pins-ngcfce4fmqvo/index',
        '/blog/collectible-music-festival-pins-ngcfce4fmqvo/index.md',
        '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy',
        '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy/index',
        '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy/index.md',
        '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk',
        '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk/index',
        '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk/index.md',
        '/blog/creating-awesome-autumn-pins-ngcfca597vwy',
        '/blog/creating-awesome-autumn-pins-ngcfca597vwy/index',
        '/blog/creating-awesome-autumn-pins-ngcfca597vwy/index.md',
        '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6',
        '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6/index',
        '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6/index.md',
        '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj',
        '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj/index',
        '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj/index.md',
        '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm',
        '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm/index',
        '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm/index.md',
        '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn',
        '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn/index',
        '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn/index.md',
        '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n',
        '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n/index',
        '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n/index.md',
        '/blog/how-are-challenge-coins-given-nkghp1rednuo',
        '/blog/how-are-challenge-coins-given-nkghp1rednuo/index',
        '/blog/how-are-challenge-coins-given-nkghp1rednuo/index.md',
        '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs',
        '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs/index',
        '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs/index.md',
        '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7',
        '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7/index',
        '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7/index.md',
        '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947',
        '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947/index',
        '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947/index.md',
        '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho',
        '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho/index',
        '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho/index.md',
        '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4',
        '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4/index',
        '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4/index.md',
        '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2',
        '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2/index',
        '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2/index.md',
        '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa',
        '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa/index',
        '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa/index.md',
        '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn',
        '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn/index',
        '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn/index.md',
        '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep',
        '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep/index',
        '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep/index.md',
        '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur',
        '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur/index',
        '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur/index.md',
        '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2',
        '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2/index',
        '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2/index.md',
        '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o',
        '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o/index',
        '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o/index.md',
        '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w',
        '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w/index',
        '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w/index.md',
        '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk',
        '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk/index',
        '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk/index.md',
        '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer',
        '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer/index',
        '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer/index.md',
        '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f',
        '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f/index',
        '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f/index.md',
        '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0',
        '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0/index',
        '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0/index.md',
        '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru',
        '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru/index',
        '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru/index.md',
        '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf',
        '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf/index',
        '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf/index.md',
        '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5',
        '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5/index',
        '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5/index.md',
        '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy',
        '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy/index',
        '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy/index.md',
        '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17',
        '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17/index',
        '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17/index.md',
        '/blog/top-5-trading-pin-upgrades-ngcfcoac5685',
        '/blog/top-5-trading-pin-upgrades-ngcfcoac5685/index',
        '/blog/top-5-trading-pin-upgrades-ngcfcoac5685/index.md',
        '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f',
        '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f/index',
        '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f/index.md',
        '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz',
        '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz/index',
        '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz/index.md',
        '/blog/what-are-police-challenge-coins-ngcfb3kay74b',
        '/blog/what-are-police-challenge-coins-ngcfb3kay74b/index',
        '/blog/what-are-police-challenge-coins-ngcfb3kay74b/index.md',
        '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf',
        '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf/index',
        '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf/index.md',
        '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x',
        '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x/index',
        '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x/index.md',
        '/buttons',
        '/buttons/index',
        '/buttons/index.md',
        '/cart',
        '/cart.html',
        '/checkout',
        '/checkout.html',
        '/cloisonne-pins',
        '/cloisonne-pins/index',
        '/cloisonne-pins/index.md',
        '/components/img-partial',
        '/components/img-partial/index',
        '/components/img-partial/index.md',
        '/contact',
        '/contact.html',
        '/contact/success',
        '/contact/success.html',
        '/custom-bottle-openers',
        '/custom-bottle-openers.html',
        '/custom-bottle-openers/index',
        '/custom-bottle-openers/index.md',
        '/custom-lanyard-attachments',
        '/custom-lanyard-attachments/index',
        '/custom-lanyard-attachments/index.md',
        '/dashboard',
        '/dashboard.html',
        '/diestruck',
        '/diestruck/index',
        '/diestruck/index.md',
        '/dog-tags',
        '/dog-tags/index',
        '/dog-tags/index.md',
        '/dual-plated-challenge-coins',
        '/dual-plated-challenge-coins/index',
        '/dual-plated-challenge-coins/index.md',
        '/dye-sublimated-lanyards',
        '/dye-sublimated-lanyards/index',
        '/dye-sublimated-lanyards/index.md',
        '/embroidered-patch-mesh-twill-charts',
        '/embroidered-patch-mesh-twill-charts/index',
        '/embroidered-patch-mesh-twill-charts/index.md',
        '/embroidered-patch-thread-colors',
        '/embroidered-patch-thread-colors/index',
        '/embroidered-patch-thread-colors/index.md',
        '/employee-pins',
        '/employee-pins/index',
        '/employee-pins/index.md',
        '/error',
        '/error.html',
        '/faq',
        '/faq.html',
        '/forgot',
        '/forgot.html',
        '/free-quote',
        '/free-quote.html',
        '/gallery',
        '/gallery.html',
        '/heat-transfer-patches',
        '/heat-transfer-patches/index',
        '/heat-transfer-patches/index.md',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/about-depot',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/about-depot.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-pricing',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-pricing.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-products',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-products.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog/_index',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog/_index.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/cart',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/cart.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/checkout',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/checkout.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial/index',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial/index.md',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact/success',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact/success.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/custom-bottle-openers',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/custom-bottle-openers.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/dashboard',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/dashboard.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/error',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/error.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/forgot',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/forgot.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/free-quote',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/free-quote.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/gallery',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/gallery.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/join',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/join.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login-email',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login-email.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order-submitted',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order-submitted.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/make-order-payment',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/make-order-payment.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/track',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/track.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/overview',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/overview.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/password-reset',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/password-reset.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-history',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-history.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-methods',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-methods.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/presentation-options',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/presentation-options.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/privacy',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/privacy.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/products',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/products.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/profile',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/profile.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote/received',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote/received.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quotes',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quotes.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revision-requests',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revision-requests.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revisions',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revisions.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/search',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/search.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/shipping-options',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/shipping-options.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/support',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/support.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/tax-exemptions',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/tax-exemptions.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/terms',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/terms.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/testimonials',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/testimonials.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/thank-you',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/thank-you.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/types',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/types.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/uploads',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/uploads.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md',
        '/imprinted-nylon-lanyards',
        '/imprinted-nylon-lanyards/index',
        '/imprinted-nylon-lanyards/index.md',
        '/imprinted-polyester-lanyards',
        '/imprinted-polyester-lanyards/index',
        '/imprinted-polyester-lanyards/index.md',
        '/imprinted-tube-lanyards',
        '/imprinted-tube-lanyards/index',
        '/imprinted-tube-lanyards/index.md',
        '/join',
        '/join.html',
        '/keychains',
        '/keychains/index',
        '/keychains/index.md',
        '/login',
        '/login-email',
        '/login-email.html',
        '/login.html',
        '/offset-pins',
        '/offset-pins/index',
        '/offset-pins/index.md',
        '/order',
        '/order-submitted',
        '/order-submitted.html',
        '/order.html',
        '/orders',
        '/orders.html',
        '/orders/make-order-payment',
        '/orders/make-order-payment.html',
        '/orders/track',
        '/orders/track.html',
        '/overview',
        '/overview.html',
        '/password-reset',
        '/password-reset.html',
        '/patch-backing',
        '/patch-backing/index',
        '/patch-backing/index.md',
        '/patch-edges',
        '/patch-edges.html',
        '/payment-history',
        '/payment-history.html',
        '/payment-methods',
        '/payment-methods.html',
        '/presentation-options',
        '/presentation-options.html',
        '/presentation-options/index',
        '/presentation-options/index.md',
        '/pricing',
        '/pricing/index',
        '/pricing/index.md',
        '/privacy',
        '/privacy.html',
        '/products',
        '/products.html',
        '/profile',
        '/profile.html',
        '/pvc-patches',
        '/pvc-patches/index',
        '/pvc-patches/index.md',
        '/quote',
        '/quote.html',
        '/quote/received',
        '/quote/received.html',
        '/quotes',
        '/quotes.html',
        '/race-medals',
        '/race-medals/index',
        '/race-medals/index.md',
        '/revision-requests',
        '/revision-requests.html',
        '/revisions',
        '/revisions.html',
        '/ribbon-pins',
        '/ribbon-pins/index',
        '/ribbon-pins/index.md',
        '/rush-trading-pin-design',
        '/rush-trading-pin-design/index',
        '/rush-trading-pin-design/index.html',
        '/search',
        '/search.html',
        '/shipping-options',
        '/shipping-options.html',
        '/silkscreen-pins',
        '/silkscreen-pins/index',
        '/silkscreen-pins/index.md',
        '/soft-enamel-pins',
        '/soft-enamel-pins/index',
        '/soft-enamel-pins/index.md',
        '/specialty-lanyards',
        '/specialty-lanyards/index',
        '/specialty-lanyards/index.md',
        '/support',
        '/support.html',
        '/tax-exemptions',
        '/tax-exemptions.html',
        '/terms',
        '/terms.html',
        '/testimonials',
        '/testimonials.html',
        '/thank-you',
        '/thank-you.html',
        '/trading-pin-design',
        '/trading-pin-design/index',
        '/trading-pin-design/index.html',
        '/trading-pins',
        '/trading-pins/index',
        '/trading-pins/index.md',
        '/types',
        '/types.html',
        '/uploads',
        '/uploads.html',
        '/usa-rush-pins',
        '/usa-rush-pins/index',
        '/usa-rush-pins/index.md',
        '/woven-patch',
        '/woven-patch/index',
        '/woven-patch/index.md',
        '/woven-polyester-lanyards',
        '/woven-polyester-lanyards/index',
        '/woven-polyester-lanyards/index.md',
    ].includes(path);
}

export function Relref(path: File): string {
    switch (path) {
    case '/':
        return 'https://coindepot.com/index.json';
    case '/100-percent-embroidered-patches':
        return 'https://patchdepot.com/100-percent-embroidered-patches/';
    case '/100-percent-embroidered-patches/index':
        return 'https://patchdepot.com/100-percent-embroidered-patches/';
    case '/100-percent-embroidered-patches/index.md':
        return 'https://patchdepot.com/100-percent-embroidered-patches/';
    case '/3d-challenge-coins':
        return 'https://coindepot.com/3d-challenge-coins/';
    case '/3d-challenge-coins/index':
        return 'https://coindepot.com/3d-challenge-coins/';
    case '/3d-challenge-coins/index.md':
        return 'https://coindepot.com/3d-challenge-coins/';
    case '/75-percent-embroidered-patches':
        return 'https://patchdepot.com/75-percent-embroidered-patches/';
    case '/75-percent-embroidered-patches/index':
        return 'https://patchdepot.com/75-percent-embroidered-patches/';
    case '/75-percent-embroidered-patches/index.md':
        return 'https://patchdepot.com/75-percent-embroidered-patches/';
    case '/_index':
        return 'https://coindepot.com/index.json';
    case '/_index.html':
        return 'https://coindepot.com/index.json';
    case '/about-depot':
        return '/about-depot/';
    case '/about-depot.html':
        return '/about-depot/';
    case '/about-us':
        return '/about-us/';
    case '/about-us.html':
        return '/about-us/';
    case '/about-us/index':
        return 'https://coindepot.com/about-us/';
    case '/about-us/index.md':
        return 'https://coindepot.com/about-us/';
    case '/all-pricing':
        return '/all-pricing/';
    case '/all-pricing.html':
        return '/all-pricing/';
    case '/all-products':
        return '/all-products/';
    case '/all-products.html':
        return '/all-products/';
    case '/blog':
        return '/blog/';
    case '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan':
        return 'https://pindepot.com/blog/10-fun-ways-to-use-custom-lapel-pins/';
    case '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan/index':
        return 'https://pindepot.com/blog/10-fun-ways-to-use-custom-lapel-pins/';
    case '/blog/10-fun-ways-to-use-custom-lapel-pins-ni7kdslpcaan/index.md':
        return 'https://pindepot.com/blog/10-fun-ways-to-use-custom-lapel-pins/';
    case '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b':
        return 'https://pindepot.com/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them/';
    case '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b/index':
        return 'https://pindepot.com/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them/';
    case '/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them-ngcfcju37q1b/index.md':
        return 'https://pindepot.com/blog/5-best-back-to-school-swag-items-whats-trending-and-where-to-get-them/';
    case '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85':
        return 'https://pindepot.com/blog/5-fun-ways-to-make-your-enamel-pins-unique/';
    case '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85/index':
        return 'https://pindepot.com/blog/5-fun-ways-to-make-your-enamel-pins-unique/';
    case '/blog/5-fun-ways-to-make-your-enamel-pins-unique-njcg7t9ijb85/index.md':
        return 'https://pindepot.com/blog/5-fun-ways-to-make-your-enamel-pins-unique/';
    case '/blog/_index':
        return '/blog/';
    case '/blog/_index.html':
        return '/blog/';
    case '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax':
        return 'https://pindepot.com/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches/';
    case '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax/index':
        return 'https://pindepot.com/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches/';
    case '/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches-ngcfchekr8ax/index.md':
        return 'https://pindepot.com/blog/boost-your-state-park-fundraising-efforts-with-custom-pins-and-patches/';
    case '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu':
        return 'https://pindepot.com/blog/bringing-depth-to-your-pins-with-3d-molds/';
    case '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu/index':
        return 'https://pindepot.com/blog/bringing-depth-to-your-pins-with-3d-molds/';
    case '/blog/bringing-depth-to-your-pins-with-3d-molds-ngcfcao1k1fu/index.md':
        return 'https://pindepot.com/blog/bringing-depth-to-your-pins-with-3d-molds/';
    case '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb':
        return 'https://pindepot.com/blog/celebrate-your-achievements-with-custom-school-pins/';
    case '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb/index':
        return 'https://pindepot.com/blog/celebrate-your-achievements-with-custom-school-pins/';
    case '/blog/celebrate-your-achievements-with-custom-school-pins-ngcfcduq00xb/index.md':
        return 'https://pindepot.com/blog/celebrate-your-achievements-with-custom-school-pins/';
    case '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g':
        return 'https://pindepot.com/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding/';
    case '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g/index':
        return 'https://pindepot.com/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding/';
    case '/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding-nhb788hk3l4g/index.md':
        return 'https://pindepot.com/blog/cheez-it-bowl-and-pop-tart-bowl-a-winning-play-for-fans-and-branding/';
    case '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy':
        return 'https://coindepot.com/blog/choosing-the-right-color-for-your-custom-challenge-coins/';
    case '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy/index':
        return 'https://coindepot.com/blog/choosing-the-right-color-for-your-custom-challenge-coins/';
    case '/blog/choosing-the-right-color-for-your-custom-challenge-coins-ngcfb1hvv5uy/index.md':
        return 'https://coindepot.com/blog/choosing-the-right-color-for-your-custom-challenge-coins/';
    case '/blog/collectible-music-festival-pins-ngcfce4fmqvo':
        return 'https://pindepot.com/blog/collectible-music-festival-pins/';
    case '/blog/collectible-music-festival-pins-ngcfce4fmqvo/index':
        return 'https://pindepot.com/blog/collectible-music-festival-pins/';
    case '/blog/collectible-music-festival-pins-ngcfce4fmqvo/index.md':
        return 'https://pindepot.com/blog/collectible-music-festival-pins/';
    case '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy':
        return 'https://pindepot.com/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins/';
    case '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy/index':
        return 'https://pindepot.com/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins/';
    case '/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins-ngcfcnle4emy/index.md':
        return 'https://pindepot.com/blog/connecting-with-customers-discover-how-businesses-are-benefiting-from-logo-pins/';
    case '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk':
        return 'https://pindepot.com/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club/';
    case '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk/index':
        return 'https://pindepot.com/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club/';
    case '/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club-ngcfcjb35apk/index.md':
        return 'https://pindepot.com/blog/crafting-unity-with-custom-pins-from-the-boys-girls-club/';
    case '/blog/creating-awesome-autumn-pins-ngcfca597vwy':
        return 'https://pindepot.com/blog/creating-awesome-autumn-pins/';
    case '/blog/creating-awesome-autumn-pins-ngcfca597vwy/index':
        return 'https://pindepot.com/blog/creating-awesome-autumn-pins/';
    case '/blog/creating-awesome-autumn-pins-ngcfca597vwy/index.md':
        return 'https://pindepot.com/blog/creating-awesome-autumn-pins/';
    case '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6':
        return 'https://coindepot.com/blog/creating-super-realistic-4d-challenge-coins/';
    case '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6/index':
        return 'https://coindepot.com/blog/creating-super-realistic-4d-challenge-coins/';
    case '/blog/creating-super-realistic-4d-challenge-coins-nhual3540it6/index.md':
        return 'https://coindepot.com/blog/creating-super-realistic-4d-challenge-coins/';
    case '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj':
        return 'https://coindepot.com/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops/';
    case '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj/index':
        return 'https://coindepot.com/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops/';
    case '/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops-njthq89778yj/index.md':
        return 'https://coindepot.com/blog/custom-made-bottle-openers-how-to-make-a-design-that-pops/';
    case '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm':
        return 'https://coindepot.com/blog/customer-spotlight-john-galloway/';
    case '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm/index':
        return 'https://coindepot.com/blog/customer-spotlight-john-galloway/';
    case '/blog/customer-spotlight-john-galloway-nkg9ydc7pnlm/index.md':
        return 'https://coindepot.com/blog/customer-spotlight-john-galloway/';
    case '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn':
        return 'https://pindepot.com/blog/embodying-mission-with-custom-school-pins/';
    case '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn/index':
        return 'https://pindepot.com/blog/embodying-mission-with-custom-school-pins/';
    case '/blog/embodying-mission-with-custom-school-pins-ngcfchontvxn/index.md':
        return 'https://pindepot.com/blog/embodying-mission-with-custom-school-pins/';
    case '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n':
        return 'https://coindepot.com/blog/high-polish-v-antique-which-should-you-choose/';
    case '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n/index':
        return 'https://coindepot.com/blog/high-polish-v-antique-which-should-you-choose/';
    case '/blog/high-polish-v-antique-which-should-you-choose-ngcfb6ffgl6n/index.md':
        return 'https://coindepot.com/blog/high-polish-v-antique-which-should-you-choose/';
    case '/blog/how-are-challenge-coins-given-nkghp1rednuo':
        return 'https://coindepot.com/blog/how-are-challenge-coins-given/';
    case '/blog/how-are-challenge-coins-given-nkghp1rednuo/index':
        return 'https://coindepot.com/blog/how-are-challenge-coins-given/';
    case '/blog/how-are-challenge-coins-given-nkghp1rednuo/index.md':
        return 'https://coindepot.com/blog/how-are-challenge-coins-given/';
    case '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs':
        return 'https://pindepot.com/blog/how-much-do-custom-pins-cost/';
    case '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs/index':
        return 'https://pindepot.com/blog/how-much-do-custom-pins-cost/';
    case '/blog/how-much-do-custom-pins-cost-nhuauxsxygxs/index.md':
        return 'https://pindepot.com/blog/how-much-do-custom-pins-cost/';
    case '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7':
        return 'https://coindepot.com/blog/how-to-design-custom-dog-tags-in-3-simple-steps/';
    case '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7/index':
        return 'https://coindepot.com/blog/how-to-design-custom-dog-tags-in-3-simple-steps/';
    case '/blog/how-to-design-custom-dog-tags-in-3-simple-steps-njpfeanj9wq7/index.md':
        return 'https://coindepot.com/blog/how-to-design-custom-dog-tags-in-3-simple-steps/';
    case '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947':
        return 'https://coindepot.com/blog/how-to-design-custom-law-enforcement-challenge-coins/';
    case '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947/index':
        return 'https://coindepot.com/blog/how-to-design-custom-law-enforcement-challenge-coins/';
    case '/blog/how-to-design-custom-law-enforcement-challenge-coins-ngcfb9h5u947/index.md':
        return 'https://coindepot.com/blog/how-to-design-custom-law-enforcement-challenge-coins/';
    case '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho':
        return 'https://pindepot.com/blog/how-to-make-custom-logo-pins-that-stand-out/';
    case '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho/index':
        return 'https://pindepot.com/blog/how-to-make-custom-logo-pins-that-stand-out/';
    case '/blog/how-to-make-custom-logo-pins-that-stand-out-ni7ma4p9d7ho/index.md':
        return 'https://pindepot.com/blog/how-to-make-custom-logo-pins-that-stand-out/';
    case '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4':
        return 'https://pindepot.com/blog/how-to-make-enamel-pins-a-step-by-step-guide/';
    case '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4/index':
        return 'https://pindepot.com/blog/how-to-make-enamel-pins-a-step-by-step-guide/';
    case '/blog/how-to-make-enamel-pins-a-step-by-step-guide-njpdzmhbtes4/index.md':
        return 'https://pindepot.com/blog/how-to-make-enamel-pins-a-step-by-step-guide/';
    case '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2':
        return 'https://coindepot.com/blog/how-to-recognize-employees-with-custom-challenge-coins/';
    case '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2/index':
        return 'https://coindepot.com/blog/how-to-recognize-employees-with-custom-challenge-coins/';
    case '/blog/how-to-recognize-employees-with-custom-challenge-coins-nj5mfg4hcvk2/index.md':
        return 'https://coindepot.com/blog/how-to-recognize-employees-with-custom-challenge-coins/';
    case '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa':
        return 'https://pindepot.com/blog/how-to-start-a-recognition-program-with-custom-pins/';
    case '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa/index':
        return 'https://pindepot.com/blog/how-to-start-a-recognition-program-with-custom-pins/';
    case '/blog/how-to-start-a-recognition-program-with-custom-pins-ng5ipvvltnpa/index.md':
        return 'https://pindepot.com/blog/how-to-start-a-recognition-program-with-custom-pins/';
    case '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn':
        return 'https://pindepot.com/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins/';
    case '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn/index':
        return 'https://pindepot.com/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins/';
    case '/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins-ngcfcly0h2zn/index.md':
        return 'https://pindepot.com/blog/know-the-difference-soft-enamel-vs-hard-enamel-lapel-pins/';
    case '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep':
        return 'https://patchdepot.com/blog/know-your-patch-types-which-is-best-for-you/';
    case '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep/index':
        return 'https://patchdepot.com/blog/know-your-patch-types-which-is-best-for-you/';
    case '/blog/know-your-patch-types-which-is-best-for-you-ngvy6kwximep/index.md':
        return 'https://patchdepot.com/blog/know-your-patch-types-which-is-best-for-you/';
    case '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur':
        return 'https://pindepot.com/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers/';
    case '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur/index':
        return 'https://pindepot.com/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers/';
    case '/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers-ngcfcfufg0ur/index.md':
        return 'https://pindepot.com/blog/master-the-art-of-creating-custom-lapel-pins-for-your-customers/';
    case '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2':
        return 'https://pindepot.com/blog/national-beta-club-pins-designs-that-wow-the-competition/';
    case '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2/index':
        return 'https://pindepot.com/blog/national-beta-club-pins-designs-that-wow-the-competition/';
    case '/blog/national-beta-club-pins-designs-that-wow-the-competition-njarl2o8eef2/index.md':
        return 'https://pindepot.com/blog/national-beta-club-pins-designs-that-wow-the-competition/';
    case '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o':
        return 'https://pindepot.com/blog/our-most-popular-pin-types-and-their-differences/';
    case '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o/index':
        return 'https://pindepot.com/blog/our-most-popular-pin-types-and-their-differences/';
    case '/blog/our-most-popular-pin-types-and-their-differences-ngcfb9vhvx4o/index.md':
        return 'https://pindepot.com/blog/our-most-popular-pin-types-and-their-differences/';
    case '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w':
        return 'https://pindepot.com/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company/';
    case '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w/index':
        return 'https://pindepot.com/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company/';
    case '/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company-ngj369egor0w/index.md':
        return 'https://pindepot.com/blog/pin-depot-awarded-as-orlandos-best-promotional-product-company/';
    case '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk':
        return 'https://pindepot.com/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins/';
    case '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk/index':
        return 'https://pindepot.com/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins/';
    case '/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins-ngcfclloqgjk/index.md':
        return 'https://pindepot.com/blog/pins-and-pizza-how-blaze-pizza-is-crafting-a-special-series-of-employee-pins/';
    case '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer':
        return 'https://pindepot.com/blog/pretzels-pilsner-and-pins/';
    case '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer/index':
        return 'https://pindepot.com/blog/pretzels-pilsner-and-pins/';
    case '/blog/pretzels-pilsner-and-pins-ngcfcb1duqer/index.md':
        return 'https://pindepot.com/blog/pretzels-pilsner-and-pins/';
    case '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f':
        return 'https://pindepot.com/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins/';
    case '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f/index':
        return 'https://pindepot.com/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins/';
    case '/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins-ngcfb9pmxt8f/index.md':
        return 'https://pindepot.com/blog/showing-your-appreciation-on-veterans-day-with-military-lapel-pins/';
    case '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0':
        return 'https://pindepot.com/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot/';
    case '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0/index':
        return 'https://pindepot.com/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot/';
    case '/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot-ngcfccvcujd0/index.md':
        return 'https://pindepot.com/blog/start-and-grow-your-etsy-enamel-pin-shop-with-pin-depot/';
    case '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru':
        return 'https://pindepot.com/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins/';
    case '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru/index':
        return 'https://pindepot.com/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins/';
    case '/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins-nkjva0g7joru/index.md':
        return 'https://pindepot.com/blog/team-mojo-disc-golf-throwing-style-into-every-round-with-custom-enamel-pins/';
    case '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf':
        return 'https://pindepot.com/blog/the-benefits-of-creating-custom-pins-for-your-next-convention/';
    case '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf/index':
        return 'https://pindepot.com/blog/the-benefits-of-creating-custom-pins-for-your-next-convention/';
    case '/blog/the-benefits-of-creating-custom-pins-for-your-next-convention-ngzj7zmf3zcf/index.md':
        return 'https://pindepot.com/blog/the-benefits-of-creating-custom-pins-for-your-next-convention/';
    case '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5':
        return 'https://coindepot.com/blog/the-story-behind-firefighter-challenge-coins/';
    case '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5/index':
        return 'https://coindepot.com/blog/the-story-behind-firefighter-challenge-coins/';
    case '/blog/the-story-behind-firefighter-challenge-coins-ngcfb4ev7zh5/index.md':
        return 'https://coindepot.com/blog/the-story-behind-firefighter-challenge-coins/';
    case '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy':
        return 'https://pindepot.com/blog/the-ultimate-guide-to-enamel-pin-backings/';
    case '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy/index':
        return 'https://pindepot.com/blog/the-ultimate-guide-to-enamel-pin-backings/';
    case '/blog/the-ultimate-guide-to-enamel-pin-backings-ngj3uomx9wiy/index.md':
        return 'https://pindepot.com/blog/the-ultimate-guide-to-enamel-pin-backings/';
    case '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17':
        return 'https://coindepot.com/blog/top-5-most-popular-coin-packaging-options/';
    case '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17/index':
        return 'https://coindepot.com/blog/top-5-most-popular-coin-packaging-options/';
    case '/blog/top-5-most-popular-coin-packaging-options-ngvzs87r8j17/index.md':
        return 'https://coindepot.com/blog/top-5-most-popular-coin-packaging-options/';
    case '/blog/top-5-trading-pin-upgrades-ngcfcoac5685':
        return 'https://pindepot.com/blog/top-5-trading-pin-upgrades/';
    case '/blog/top-5-trading-pin-upgrades-ngcfcoac5685/index':
        return 'https://pindepot.com/blog/top-5-trading-pin-upgrades/';
    case '/blog/top-5-trading-pin-upgrades-ngcfcoac5685/index.md':
        return 'https://pindepot.com/blog/top-5-trading-pin-upgrades/';
    case '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f':
        return 'https://coindepot.com/blog/understanding-challenge-coins-meaning-history-and-tradition/';
    case '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f/index':
        return 'https://coindepot.com/blog/understanding-challenge-coins-meaning-history-and-tradition/';
    case '/blog/understanding-challenge-coins-meaning-history-and-tradition-ngcfb8q0uy3f/index.md':
        return 'https://coindepot.com/blog/understanding-challenge-coins-meaning-history-and-tradition/';
    case '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz':
        return 'https://pindepot.com/blog/using-pins-for-cancer-awareness/';
    case '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz/index':
        return 'https://pindepot.com/blog/using-pins-for-cancer-awareness/';
    case '/blog/using-pins-for-cancer-awareness-ngcfcdg2igaz/index.md':
        return 'https://pindepot.com/blog/using-pins-for-cancer-awareness/';
    case '/blog/what-are-police-challenge-coins-ngcfb3kay74b':
        return 'https://coindepot.com/blog/what-are-police-challenge-coins/';
    case '/blog/what-are-police-challenge-coins-ngcfb3kay74b/index':
        return 'https://coindepot.com/blog/what-are-police-challenge-coins/';
    case '/blog/what-are-police-challenge-coins-ngcfb3kay74b/index.md':
        return 'https://coindepot.com/blog/what-are-police-challenge-coins/';
    case '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf':
        return 'https://coindepot.com/blog/what-are-spinner-challenge-coins/';
    case '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf/index':
        return 'https://coindepot.com/blog/what-are-spinner-challenge-coins/';
    case '/blog/what-are-spinner-challenge-coins-nj564zjkwbdf/index.md':
        return 'https://coindepot.com/blog/what-are-spinner-challenge-coins/';
    case '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x':
        return 'https://coindepot.com/blog/what-are-the-top-5-challenge-coin-upgrades/';
    case '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x/index':
        return 'https://coindepot.com/blog/what-are-the-top-5-challenge-coin-upgrades/';
    case '/blog/what-are-the-top-5-challenge-coin-upgrades-ngcfb6y9bg6x/index.md':
        return 'https://coindepot.com/blog/what-are-the-top-5-challenge-coin-upgrades/';
    case '/buttons':
        return 'https://coindepot.com/buttons/';
    case '/buttons/index':
        return 'https://coindepot.com/buttons/';
    case '/buttons/index.md':
        return 'https://coindepot.com/buttons/';
    case '/cart':
        return '/cart/';
    case '/cart.html':
        return '/cart/';
    case '/checkout':
        return '/checkout/';
    case '/checkout.html':
        return '/checkout/';
    case '/cloisonne-pins':
        return 'https://pindepot.com/cloisonne-pins/';
    case '/cloisonne-pins/index':
        return 'https://pindepot.com/cloisonne-pins/';
    case '/cloisonne-pins/index.md':
        return 'https://pindepot.com/cloisonne-pins/';
    case '/components/img-partial':
        return '/components/img-partial/';
    case '/components/img-partial/index':
        return '/components/img-partial/';
    case '/components/img-partial/index.md':
        return '/components/img-partial/';
    case '/contact':
        return '/contact/';
    case '/contact.html':
        return '/contact/';
    case '/contact/success':
        return '/contact/success/';
    case '/contact/success.html':
        return '/contact/success/';
    case '/custom-bottle-openers':
        return '/custom-bottle-openers/';
    case '/custom-bottle-openers.html':
        return '/custom-bottle-openers/';
    case '/custom-bottle-openers/index':
        return 'https://coindepot.com/custom-bottle-openers/';
    case '/custom-bottle-openers/index.md':
        return 'https://coindepot.com/custom-bottle-openers/';
    case '/custom-lanyard-attachments':
        return 'https://lanyarddepot.com/custom-lanyard-attachments/';
    case '/custom-lanyard-attachments/index':
        return 'https://lanyarddepot.com/custom-lanyard-attachments/';
    case '/custom-lanyard-attachments/index.md':
        return 'https://lanyarddepot.com/custom-lanyard-attachments/';
    case '/dashboard':
        return '/dashboard/';
    case '/dashboard.html':
        return '/dashboard/';
    case '/diestruck':
        return 'https://pindepot.com/diestruck/';
    case '/diestruck/index':
        return 'https://pindepot.com/diestruck/';
    case '/diestruck/index.md':
        return 'https://pindepot.com/diestruck/';
    case '/dog-tags':
        return 'https://coindepot.com/dog-tags/';
    case '/dog-tags/index':
        return 'https://coindepot.com/dog-tags/';
    case '/dog-tags/index.md':
        return 'https://coindepot.com/dog-tags/';
    case '/dual-plated-challenge-coins':
        return 'https://coindepot.com/dual-plated-challenge-coins/';
    case '/dual-plated-challenge-coins/index':
        return 'https://coindepot.com/dual-plated-challenge-coins/';
    case '/dual-plated-challenge-coins/index.md':
        return 'https://coindepot.com/dual-plated-challenge-coins/';
    case '/dye-sublimated-lanyards':
        return 'https://lanyarddepot.com/dye-sublimated-lanyards/';
    case '/dye-sublimated-lanyards/index':
        return 'https://lanyarddepot.com/dye-sublimated-lanyards/';
    case '/dye-sublimated-lanyards/index.md':
        return 'https://lanyarddepot.com/dye-sublimated-lanyards/';
    case '/embroidered-patch-mesh-twill-charts':
        return 'https://patchdepot.com/embroidered-patch-mesh-twill-charts/';
    case '/embroidered-patch-mesh-twill-charts/index':
        return 'https://patchdepot.com/embroidered-patch-mesh-twill-charts/';
    case '/embroidered-patch-mesh-twill-charts/index.md':
        return 'https://patchdepot.com/embroidered-patch-mesh-twill-charts/';
    case '/embroidered-patch-thread-colors':
        return 'https://patchdepot.com/embroidered-patch-thread-colors/';
    case '/embroidered-patch-thread-colors/index':
        return 'https://patchdepot.com/embroidered-patch-thread-colors/';
    case '/embroidered-patch-thread-colors/index.md':
        return 'https://patchdepot.com/embroidered-patch-thread-colors/';
    case '/employee-pins':
        return 'https://pindepot.com/employee-pins/';
    case '/employee-pins/index':
        return 'https://pindepot.com/employee-pins/';
    case '/employee-pins/index.md':
        return 'https://pindepot.com/employee-pins/';
    case '/error':
        return '/error/';
    case '/error.html':
        return '/error/';
    case '/faq':
        return 'https://coindepot.com/faq/';
    case '/faq.html':
        return 'https://coindepot.com/faq/';
    case '/forgot':
        return '/forgot/';
    case '/forgot.html':
        return '/forgot/';
    case '/free-quote':
        return '/quote/';
    case '/free-quote.html':
        return '/quote/';
    case '/gallery':
        return '/gallery/';
    case '/gallery.html':
        return '/gallery/';
    case '/heat-transfer-patches':
        return 'https://patchdepot.com/heat-transfer-patches/';
    case '/heat-transfer-patches/index':
        return 'https://patchdepot.com/heat-transfer-patches/';
    case '/heat-transfer-patches/index.md':
        return 'https://patchdepot.com/heat-transfer-patches/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/about-depot':
        return 'https://coindepot.com/about-depot/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/about-depot.html':
        return 'https://coindepot.com/about-depot/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-pricing':
        return 'https://coindepot.com/all-pricing/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-pricing.html':
        return 'https://coindepot.com/all-pricing/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-products':
        return 'https://coindepot.com/all-products/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/all-products.html':
        return 'https://coindepot.com/all-products/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog':
        return 'https://coindepot.com/blog/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog/_index':
        return 'https://coindepot.com/blog/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/blog/_index.html':
        return 'https://coindepot.com/blog/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/cart':
        return 'https://coindepot.com/cart/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/cart.html':
        return 'https://coindepot.com/cart/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/checkout':
        return 'https://coindepot.com/checkout/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/checkout.html':
        return 'https://coindepot.com/checkout/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial':
        return 'https://coindepot.com/components/img-partial/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial/index':
        return 'https://coindepot.com/components/img-partial/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/components/img-partial/index.md':
        return 'https://coindepot.com/components/img-partial/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact':
        return 'https://coindepot.com/contact/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact.html':
        return 'https://coindepot.com/contact/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact/success':
        return 'https://coindepot.com/contact/success/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/contact/success.html':
        return 'https://coindepot.com/contact/success/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/custom-bottle-openers':
        return 'https://lanyarddepot.com/custom-bottle-openers/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/custom-bottle-openers.html':
        return 'https://lanyarddepot.com/custom-bottle-openers/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/dashboard':
        return 'https://coindepot.com/dashboard/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/dashboard.html':
        return 'https://coindepot.com/dashboard/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/error':
        return 'https://coindepot.com/error/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/error.html':
        return 'https://coindepot.com/error/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/forgot':
        return 'https://coindepot.com/forgot/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/forgot.html':
        return 'https://coindepot.com/forgot/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/free-quote':
        return 'https://coindepot.com/quote/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/free-quote.html':
        return 'https://coindepot.com/quote/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/gallery':
        return 'https://coindepot.com/gallery/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/gallery.html':
        return 'https://coindepot.com/gallery/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/join':
        return 'https://coindepot.com/join/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/join.html':
        return 'https://coindepot.com/join/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login':
        return 'https://coindepot.com/login/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login-email':
        return 'https://coindepot.com/login-email/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login-email.html':
        return 'https://coindepot.com/login-email/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/login.html':
        return 'https://coindepot.com/login/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order':
        return 'https://coindepot.com/order/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order-submitted':
        return 'https://coindepot.com/order-submitted/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order-submitted.html':
        return 'https://coindepot.com/order-submitted/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/order.html':
        return 'https://coindepot.com/order/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders':
        return 'https://coindepot.com/orders/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders.html':
        return 'https://coindepot.com/orders/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/make-order-payment':
        return 'https://coindepot.com/orders/make-order-payment/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/make-order-payment.html':
        return 'https://coindepot.com/orders/make-order-payment/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/track':
        return 'https://coindepot.com/orders/track/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/orders/track.html':
        return 'https://coindepot.com/orders/track/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/overview':
        return 'https://coindepot.com/overview/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/overview.html':
        return 'https://coindepot.com/overview/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/password-reset':
        return 'https://coindepot.com/password-reset/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/password-reset.html':
        return 'https://coindepot.com/password-reset/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-history':
        return 'https://coindepot.com/payment-history/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-history.html':
        return 'https://coindepot.com/payment-history/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-methods':
        return 'https://coindepot.com/payment-methods/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/payment-methods.html':
        return 'https://coindepot.com/payment-methods/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/presentation-options':
        return 'https://lanyarddepot.com/presentation-options/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/presentation-options.html':
        return 'https://lanyarddepot.com/presentation-options/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/privacy':
        return 'https://coindepot.com/privacy/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/privacy.html':
        return 'https://coindepot.com/privacy/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/products':
        return 'https://coindepot.com/products/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/products.html':
        return 'https://coindepot.com/products/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/profile':
        return 'https://coindepot.com/profile/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/profile.html':
        return 'https://coindepot.com/profile/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote':
        return 'https://coindepot.com/quote-search/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote.html':
        return 'https://coindepot.com/quote-search/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote/received':
        return 'https://coindepot.com/quote/received/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quote/received.html':
        return 'https://coindepot.com/quote/received/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quotes':
        return 'https://coindepot.com/quotes/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/quotes.html':
        return 'https://coindepot.com/quotes/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revision-requests':
        return 'https://coindepot.com/revision-requests/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revision-requests.html':
        return 'https://coindepot.com/revision-requests/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revisions':
        return 'https://coindepot.com/revisions/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/revisions.html':
        return 'https://coindepot.com/revisions/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/search':
        return 'https://coindepot.com/search/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/search.html':
        return 'https://coindepot.com/search/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/shipping-options':
        return 'https://coindepot.com/shipping-options/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/shipping-options.html':
        return 'https://coindepot.com/shipping-options/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/support':
        return 'https://coindepot.com/support/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/support.html':
        return 'https://coindepot.com/support/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/tax-exemptions':
        return 'https://coindepot.com/tax-exemptions/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/tax-exemptions.html':
        return 'https://coindepot.com/tax-exemptions/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/terms':
        return 'https://coindepot.com/terms/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/terms.html':
        return 'https://coindepot.com/terms/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/testimonials':
        return 'https://coindepot.com/testimonials/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/testimonials.html':
        return 'https://coindepot.com/testimonials/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/thank-you':
        return 'https://coindepot.com/thank-you/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/thank-you.html':
        return 'https://coindepot.com/thank-you/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/types':
        return 'https://coindepot.com/types/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/types.html':
        return 'https://coindepot.com/types/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/uploads':
        return 'https://coindepot.com/uploads/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/depot/content/uploads.html':
        return 'https://coindepot.com/uploads/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components':
        return '/components/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index':
        return '/components/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md':
        return '/components/';
    case '/imprinted-nylon-lanyards':
        return 'https://lanyarddepot.com/imprinted-nylon-lanyards/';
    case '/imprinted-nylon-lanyards/index':
        return 'https://lanyarddepot.com/imprinted-nylon-lanyards/';
    case '/imprinted-nylon-lanyards/index.md':
        return 'https://lanyarddepot.com/imprinted-nylon-lanyards/';
    case '/imprinted-polyester-lanyards':
        return 'https://lanyarddepot.com/imprinted-polyester-lanyards/';
    case '/imprinted-polyester-lanyards/index':
        return 'https://lanyarddepot.com/imprinted-polyester-lanyards/';
    case '/imprinted-polyester-lanyards/index.md':
        return 'https://lanyarddepot.com/imprinted-polyester-lanyards/';
    case '/imprinted-tube-lanyards':
        return 'https://lanyarddepot.com/imprinted-tube-lanyards/';
    case '/imprinted-tube-lanyards/index':
        return 'https://lanyarddepot.com/imprinted-tube-lanyards/';
    case '/imprinted-tube-lanyards/index.md':
        return 'https://lanyarddepot.com/imprinted-tube-lanyards/';
    case '/join':
        return '/join/';
    case '/join.html':
        return '/join/';
    case '/keychains':
        return 'https://coindepot.com/keychains/';
    case '/keychains/index':
        return 'https://coindepot.com/keychains/';
    case '/keychains/index.md':
        return 'https://coindepot.com/keychains/';
    case '/login':
        return '/login/';
    case '/login-email':
        return '/login-email/';
    case '/login-email.html':
        return '/login-email/';
    case '/login.html':
        return '/login/';
    case '/offset-pins':
        return 'https://pindepot.com/offset-pins/';
    case '/offset-pins/index':
        return 'https://pindepot.com/offset-pins/';
    case '/offset-pins/index.md':
        return 'https://pindepot.com/offset-pins/';
    case '/order':
        return '/order/';
    case '/order-submitted':
        return '/order-submitted/';
    case '/order-submitted.html':
        return '/order-submitted/';
    case '/order.html':
        return '/order/';
    case '/orders':
        return '/orders/';
    case '/orders.html':
        return '/orders/';
    case '/orders/make-order-payment':
        return '/orders/make-order-payment/';
    case '/orders/make-order-payment.html':
        return '/orders/make-order-payment/';
    case '/orders/track':
        return '/orders/track/';
    case '/orders/track.html':
        return '/orders/track/';
    case '/overview':
        return '/overview/';
    case '/overview.html':
        return '/overview/';
    case '/password-reset':
        return '/password-reset/';
    case '/password-reset.html':
        return '/password-reset/';
    case '/patch-backing':
        return 'https://patchdepot.com/patch-backing/';
    case '/patch-backing/index':
        return 'https://patchdepot.com/patch-backing/';
    case '/patch-backing/index.md':
        return 'https://patchdepot.com/patch-backing/';
    case '/patch-edges':
        return 'https://patchdepot.com/patch-edges/';
    case '/patch-edges.html':
        return 'https://patchdepot.com/patch-edges/';
    case '/payment-history':
        return '/payment-history/';
    case '/payment-history.html':
        return '/payment-history/';
    case '/payment-methods':
        return '/payment-methods/';
    case '/payment-methods.html':
        return '/payment-methods/';
    case '/presentation-options':
        return '/presentation-options/';
    case '/presentation-options.html':
        return '/presentation-options/';
    case '/presentation-options/index':
        return 'https://coindepot.com/presentation-options/';
    case '/presentation-options/index.md':
        return 'https://coindepot.com/presentation-options/';
    case '/pricing':
        return 'https://coindepot.com/pricing/';
    case '/pricing/index':
        return 'https://coindepot.com/pricing/';
    case '/pricing/index.md':
        return 'https://coindepot.com/pricing/';
    case '/privacy':
        return '/privacy/';
    case '/privacy.html':
        return '/privacy/';
    case '/products':
        return '/products/';
    case '/products.html':
        return '/products/';
    case '/profile':
        return '/profile/';
    case '/profile.html':
        return '/profile/';
    case '/pvc-patches':
        return 'https://patchdepot.com/pvc-patches/';
    case '/pvc-patches/index':
        return 'https://patchdepot.com/pvc-patches/';
    case '/pvc-patches/index.md':
        return 'https://patchdepot.com/pvc-patches/';
    case '/quote':
        return '/quote-search/';
    case '/quote.html':
        return '/quote-search/';
    case '/quote/received':
        return '/quote/received/';
    case '/quote/received.html':
        return '/quote/received/';
    case '/quotes':
        return '/quotes/';
    case '/quotes.html':
        return '/quotes/';
    case '/race-medals':
        return 'https://coindepot.com/race-medals/';
    case '/race-medals/index':
        return 'https://coindepot.com/race-medals/';
    case '/race-medals/index.md':
        return 'https://coindepot.com/race-medals/';
    case '/revision-requests':
        return '/revision-requests/';
    case '/revision-requests.html':
        return '/revision-requests/';
    case '/revisions':
        return '/revisions/';
    case '/revisions.html':
        return '/revisions/';
    case '/ribbon-pins':
        return 'https://pindepot.com/ribbon-pins/';
    case '/ribbon-pins/index':
        return 'https://pindepot.com/ribbon-pins/';
    case '/ribbon-pins/index.md':
        return 'https://pindepot.com/ribbon-pins/';
    case '/rush-trading-pin-design':
        return 'https://pindepot.com/rush-trading-pin-design/';
    case '/rush-trading-pin-design/index':
        return 'https://pindepot.com/rush-trading-pin-design/';
    case '/rush-trading-pin-design/index.html':
        return 'https://pindepot.com/rush-trading-pin-design/';
    case '/search':
        return '/search/';
    case '/search.html':
        return '/search/';
    case '/shipping-options':
        return '/shipping-options/';
    case '/shipping-options.html':
        return '/shipping-options/';
    case '/silkscreen-pins':
        return 'https://pindepot.com/silkscreen-pins/';
    case '/silkscreen-pins/index':
        return 'https://pindepot.com/silkscreen-pins/';
    case '/silkscreen-pins/index.md':
        return 'https://pindepot.com/silkscreen-pins/';
    case '/soft-enamel-pins':
        return 'https://pindepot.com/soft-enamel-pins/';
    case '/soft-enamel-pins/index':
        return 'https://pindepot.com/soft-enamel-pins/';
    case '/soft-enamel-pins/index.md':
        return 'https://pindepot.com/soft-enamel-pins/';
    case '/specialty-lanyards':
        return 'https://lanyarddepot.com/specialty-lanyards/';
    case '/specialty-lanyards/index':
        return 'https://lanyarddepot.com/specialty-lanyards/';
    case '/specialty-lanyards/index.md':
        return 'https://lanyarddepot.com/specialty-lanyards/';
    case '/support':
        return '/support/';
    case '/support.html':
        return '/support/';
    case '/tax-exemptions':
        return '/tax-exemptions/';
    case '/tax-exemptions.html':
        return '/tax-exemptions/';
    case '/terms':
        return '/terms/';
    case '/terms.html':
        return '/terms/';
    case '/testimonials':
        return '/testimonials/';
    case '/testimonials.html':
        return '/testimonials/';
    case '/thank-you':
        return '/thank-you/';
    case '/thank-you.html':
        return '/thank-you/';
    case '/trading-pin-design':
        return 'https://pindepot.com/trading-pin-design/';
    case '/trading-pin-design/index':
        return 'https://pindepot.com/trading-pin-design/';
    case '/trading-pin-design/index.html':
        return 'https://pindepot.com/trading-pin-design/';
    case '/trading-pins':
        return 'https://pindepot.com/trading-pins/';
    case '/trading-pins/index':
        return 'https://pindepot.com/trading-pins/';
    case '/trading-pins/index.md':
        return 'https://pindepot.com/trading-pins/';
    case '/types':
        return '/types/';
    case '/types.html':
        return '/types/';
    case '/uploads':
        return '/uploads/';
    case '/uploads.html':
        return '/uploads/';
    case '/usa-rush-pins':
        return 'https://pindepot.com/usa-rush-pins/';
    case '/usa-rush-pins/index':
        return 'https://pindepot.com/usa-rush-pins/';
    case '/usa-rush-pins/index.md':
        return 'https://pindepot.com/usa-rush-pins/';
    case '/woven-patch':
        return 'https://patchdepot.com/woven-patch/';
    case '/woven-patch/index':
        return 'https://patchdepot.com/woven-patch/';
    case '/woven-patch/index.md':
        return 'https://patchdepot.com/woven-patch/';
    case '/woven-polyester-lanyards':
        return 'https://lanyarddepot.com/woven-polyester-lanyards/';
    case '/woven-polyester-lanyards/index':
        return 'https://lanyarddepot.com/woven-polyester-lanyards/';
    case '/woven-polyester-lanyards/index.md':
        return 'https://lanyarddepot.com/woven-polyester-lanyards/';
    }
}
